import { render, staticRenderFns } from "./StepProducts.vue?vue&type=template&id=6a84677e&lang=html&"
import script from "./StepProducts.vue?vue&type=script&lang=js&"
export * from "./StepProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports